import Widget from '@/dollar-cost-average/widget.vue';
import {
    CallableMethods,
    createInstance,
    GlobalMethods,
    initialize,
    InstanceTypes,
    OrderMethodNames,
    OrderMethods,
    processQueue,
    WalletAddressMethodNames,
    WalletAddressMethods
} from '@btcdirect/embeddable-loader';
import { getWindowObject } from '@btcdirect/functions';
import { MethodParameters } from '@btcdirect/shared/src/types';
import { reactive } from 'vue';

const instanceParameters = reactive<MethodParameters>({});

/**
 * Actually loads the widget instance.
 */
function load(): void {
    const windowObject = getWindowObject();

    // Create the instance
    const instance = createInstance(InstanceTypes.DOLLAR_COST_AVERAGE, windowObject);

    // Set the root properties to pass to the Vue app
    const props = { startInOverview: instance.config.startInOverview };

    // Initialize the actual widget
    initialize(Widget, instance, props, instanceParameters, windowObject);

    const specificMethods: CallableMethods = {
        [WalletAddressMethodNames.ADDRESSES]: WalletAddressMethods[WalletAddressMethodNames.ADDRESSES],
        [WalletAddressMethodNames.ADDRESS_SELECT]: WalletAddressMethods[WalletAddressMethodNames.ADDRESS_SELECT],
        [OrderMethodNames.CURRENCIES]: OrderMethods[OrderMethodNames.CURRENCIES]
    };

    // Set the allowed methods for this widget
    const callableMethods = Object.assign({}, GlobalMethods, specificMethods);

    // Process the method calls that are queued
    processQueue(instance, instanceParameters, callableMethods, windowObject);
}

/**
 * Actually call the loader to initialize the widget
 */
load();
